export const SYNC_ZWAVE_DEVICES_BY_ROOMS = '@@zWaveDevicesByRooms/syncZWaveDevicesByRooms'

export const RESET_ZWAVE_DEVICES_BY_ROOMS = '@@zWaveDevicesByRooms/reset'

export const UPDATE_ZWAVE_DEVICES_BY_ROOMS = '@@zWaveDevicesByRooms/updateZWaveDevicesByRooms'
